<template>
    <div class="cart-index">
        <div class="cart-ads-btn">
            <span style="width: 60px;font-size: 20px">购物车</span>
            <div style="width: 65%;align-items: center;line-height: 30px;display: flex;align-items: center">
                <span class="ads-btn" @click="toAds"><span class="el-icon-location-information"></span> {{adsDetailed}}
                <span class="el-icon-arrow-right"></span>
            </span>
            </div>
            <span style="width: 30px;font-size: 15px" @click="toEdit">编辑</span>
        </div>
        <div class="nocart" v-if="carts.length<0">
            <img src="./../../assets/noCart.png"/>
        </div>
        <div v-else style="padding-bottom: 102px; background-color: #eeeeef;">
            <div class="cart-sku" v-for="item in carts">
                <van-checkbox v-model="item.checked" class="xuan" @click="checkedDan(item)"></van-checkbox>
                <div style="display: block;width: 90%;">
                    <van-card
                            :price="item.sellingPrice"
                            :desc="item.specs"
                            :title="item.spuName"
                            :thumb="item.coverImg"
                            :origin-price="item.costPrice"
                    >
                        <div slot="footer">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content:space-between;">
                                    <span style="font-size: 12px">数量</span>
                                    <van-stepper v-model="item.skuNum" @plus="updataSpmCart(item.id,1)"
                                                 @minus="updataSpmCart(item.id,-1)"/>
                                </div>
                            </van-cell>
                        </div>
                    </van-card>
                </div>
            </div>
        </div>
        <div>
            <van-submit-bar
                    v-if="!showBtn"
                    style="margin-bottom: 53px"
                    :price="total"
                    button-text="提交订单"
                    @submit="onSubmit">
                <van-checkbox v-model="checked" @click="all">全选</van-checkbox>
            </van-submit-bar>
            <van-submit-bar
                    v-if="showBtn"
                    style="margin-bottom: 53px"
                    button-text="删除"
                    @submit="delCarts"
                    class="del"
            >
                <van-checkbox v-model="checked" style="width: 90%" @click="all">全选</van-checkbox>
            </van-submit-bar>
        </div>
        <van-popup v-model="showBottom" position="bottom" :overlay="true" lock-scroll class="ads-pop">
            <div>
                <span class="el-icon-close" style="position: absolute;right: 5px;top: 5px;font-size: 20px"
                      @click="guanbi"></span>
                <span style="display: block;text-align: center;font-size: 16px;font-weight: bold;margin-top: 18px">配送地址</span>
            </div>
            <div class="ads-items">
                <div class="ads-item" v-for="item in list" @click="setAds(item)">
                    <span class="el-icon-location-information" style="font-size: 18px;font-weight: bold"
                          v-if="item.id!=addressId"></span>
                    <span class="el-icon-check" style="font-size: 18px;color: #ff4d51;font-weight: bold"
                          v-if="item.id==addressId"></span>
                    <div style="display: flex;flex-direction: column;margin-left: 10px">
                        <span style="font-size: 15px;font-weight:bold">{{item.adsDetailed}}</span>
                        <span style="font-size: 11px;margin-top: 5px">{{item.province}}{{item.city==item.province?'':item.city}}{{item.county}}</span>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName, setCartIds} from "../../utils/auth";

    export default {
        data() {
            return {
                token: '',
                deptId: '',
                carts: [],
                checked: false,
                total: 0,
                skuSize: 0,
                showBtn: false,
                adsDetailed: '',
                showBottom: false,

                addressId: '',
                list: [],
            };
        },
        created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie('spmToken')
            this.getCarts()
            this.getAddress()
        },
        methods: {
            async getCarts() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/spm/getSpmCartList", data)
                this.carts = res.carts
                this.skuSize = res.skuSize
                if (res.total) {
                    this.total = res.total
                } else {
                    this.total = 0
                }
                if (res.carts.length) {
                    var checked = true
                    res.carts.forEach(item => {
                        if (!item.checked) {
                            checked = item.checked
                        }
                    })
                    this.checked = checked
                }
            },
            async getAddress() {
                let data = {
                    adsId: this.adsId,
                    token: this.token
                }
                let res = await this.$get("/spm/getSpmAddressInfo", data)
                this.addressInfo = res.info
                if (res.info && res.info.id) {
                    var adsDetailed = res.info.province
                    if (res.info.province != res.info.city) {
                        adsDetailed = adsDetailed + res.info.city
                    }
                    this.adsDetailed = adsDetailed + res.info.county + res.info.addressDetail
                    this.adsId = res.info.id
                }
            },

            toAds() {
                this.showBottom = true
                this.getAddressList()
            },
            guanbi() {
                this.showBottom = false
            },
            async getAddressList() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/spm/getSpmAddressList", data)
                this.list = res.list
                this.addressId = res.adsId
            },
            setAds(item) {
                this.showBottom = false
                this.adsId = item.id
                this.getAddress()
            },

            async updataSpmCart(id, num) {
                let data = {
                    token: this.token,
                    cartId: id,
                    num: num,
                }
                let res = await this.$post("/spm/updataSpmCart", data)
                if (res.code == 200) {
                    this.skuSize = res.skuSize
                    if (res.total) {
                        this.total = res.total
                    } else {
                        this.total = 0
                    }
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            async checkedDan(item) {
                let date = {
                    cartId: item.id,
                    checked: item.checked,
                    token: this.token,
                }
                let res = await this.$post("/spm/checkedSpmCart", date)
                if (res.code == 200) {
                    this.skuSize = res.skuSize
                    if (res.total) {
                        this.total = res.total
                    } else {
                        this.total = 0
                    }
                    this.checked = res.checked
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            async all() {
                let res = await this.$post("/spm/updataSpmCartAll", {token: this.token, checked: this.checked})
                this.skuSize = res.skuSize
                if (res.total) {
                    this.total = res.total
                } else {
                    this.total = 0
                }
                this.carts.forEach(item => {
                    item.checked = this.checked
                })
            },

            delCarts() {
                this.$dialog.confirm({
                    title: '操作',
                    message: '是否删除选中的 ' + this.skuSize + ' 种商品?'
                }).then(async () => {
                    let data = {
                        token: this.token
                    }
                    let res = await this.$post("/spm/delSpmCarts", data)
                    if (res.code == 200) {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: '#1989fa'
                        });
                        this.getCarts()
                    } else {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: 'red'
                        });
                    }
                }).catch(() => {
                    console.log("取消")
                });
            },

            toEdit() {
                this.showBtn = !this.showBtn
            },

            async onSubmit() {
                var ids = []
                this.carts.forEach(item => {
                    if (item.checked) {
                        ids.push(item.id)
                    }
                })
                let data = {
                    idstr: JSON.stringify(ids),
                    token: this.token
                }
                let res = await this.$post("/spm/isPass ", data)
                if (res.code == 200) {
                    setCartIds(JSON.stringify(ids))
                    this.$router.push('/buyCart/' + this.deptId)
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .cart-index {
        background-color: #eeeeef;
        height: 100%;
        padding-top: 30px;
    }

    .nocart {
        width: 80%;
        margin: auto;
        padding-top: 100px
    }

    .van-card {
        position: relative;
        box-sizing: border-box;
        padding: 0.21333rem 0.2rem;
        color: #323233;
        font-size: 0.32rem;
        background-color: #FFFFFF;
    }

    .cart-sku {
        background-color: #FFFFFF;
        display: flex;
        flex-direction: row;
        width: 95%;
        margin: auto;
        margin-bottom: 5px;
    }

    .xuan {
        font-size: 13px;
        margin: 0px 8px;
    }

    .cart-ads-btn {
        width: 100%;
        position: fixed;
        top: 0px;
        display: flex;
        flex-direction: row;
        height: 30px;
        line-height: 30px;
        padding: 0px 8px;
        justify-content: space-between;
        align-items: center;
        background-color: #eeeeef;
        z-index: 99;
    }

    .del /deep/ .van-submit-bar__button {
        width: 60px;
        height: 1.06667rem;
        font-weight: 500;
        border: none;

    }

    .del /deep/ .van-submit-bar__button--danger {
        background: #FFFFFF;
        color: #000000;
        border: #e5e5e5 solid 1px;
        height: 28px;
        padding: 0px 5px;
    }

    .ads-btn {
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        /*border-radius: 8px;*/
        padding: 0px 8px
    }

    .ads-items {
        display: flex;
        flex-direction: column;
        width: 90%;
        margin: auto;
        margin-top: 18px;
        height: 395px;
        overflow: auto;
    }

    .ads-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 12px 0px;
    }

    .ads-pop {
        height: 450px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

</style>
